import React from 'react';
import { Skeleton } from '@mui/material';
import styles from './ActivityItem.module.css';

const ActivityItemSkeleton = ({ borderBottom = true }) => {
  return (
    <>
      <div className="row m-0">
        <div className={`col-12 px-1 ${styles.paddingyx} ${borderBottom ? styles.borderBottom : ''}`}>
          <div className="row">
            <div className="col px-0 ml-2">
              <div className="text-tertiary fw-700">
                <Skeleton variant="text" sx={{ bgcolor: 'grey.900', fontSize: '1.2rem' }} />
              </div>

              <div className="font-smaller text-secondary">
                <Skeleton variant="text" sx={{ bgcolor: 'grey.900', fontSize: '.875rem' }} />
              </div>
            </div>
            <div className="col-auto text-right">
              <div className="text-green fw-500">
                <Skeleton
                  variant="text"
                  width={'100px'}
                  sx={{ bgcolor: 'grey.900', fontSize: '1.2rem' }}
                />
              </div>
              <div className="d-flex justify-content-end">
                <Skeleton
                  width={'60px'}
                  variant="text"
                  sx={{ bgcolor: 'grey.900', fontSize: '.875rem' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ActivityItemSkeleton;